module.exports = __webpack_public_path__ + "static/media/Blue_Back.c8edaa75.svg";